<template>
    <section>
        <div class="campaigns-header">
            <h3>Campaigns</h3>
            <div>
                <ds-filled-button
                    data-qa="add-sequence"
                    class="only-desktop"
                    @click="showAddSequenceModal"
                >
                    Add to Sequence
                </ds-filled-button>
                <add-sequence-to-contact-form ref="sequenceModal" :contact="contact" />
            </div>
        </div>
        <div class="campaigns-sub-header">
            <h3>Active sequences</h3>
        </div>
        <div v-if="isActiveSequences" data-qa="active-seq-table">
            <table class="table-scroller">
                <tr v-for="(activeSequence, index) in activeSequences" :key="index" class="camp-row">
                    <td style="width: 5%" class="icon-row">
                        <ds-icon class="external-look" name="tag" />
                    </td>
                    <td data-qa="seq-details-section" style="width: 95%">
                        <div class="seq-details">
                            <div>
                                <h6 class="semibold">
                                    {{ activeSequence.flowName }}
                                </h6>
                                <span> {{ activeSequence.funnelName }} </span>
                            </div>
                            <div class="seq-remove">
                                <div v-for="(body, ind) in (activeSequence.started.split(','))" :key="ind">
                                    <span> {{ body }} </span>
                                </div>

                                <div class="campaign-action">
                                    <ds-outline-button
                                        data-qa="stop-sequence"
                                        width="200"
                                        @click="removeSequence(activeSequence)"
                                    >
                                        Remove
                                    </ds-outline-button>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div v-else class="no-data" data-qa="no-active-seq">
            There are no active sequences for {{ contact.firstName }}.
        </div>
        <div class="sequence-header">
            <div class="campaigns-sub-header">
                <h3>Recent automation history</h3>
            </div>

            <div v-if="isRecentActivities" data-qa="recent-seq-table">
                <table class="table-scroller">
                    <tr v-for="(recentCampaign, index) in recentCampaigns" :key="index" class="camp-row">
                        <td style="width: 5%">
                            <div>
                                <ds-icon class="external-look" name="note" />
                            </div>
                        </td>
                        <td>
                            <div data-qa="recent-seq-detail" class="seq-details">
                                <div>
                                    <div class="sequence-info">
                                        <h6 class="semibold">
                                            {{ recentCampaign.itemDescriptionTitle }}
                                        </h6>
                                        <div v-if="recentCampaign.flowItemType.endsWith('Email')">
                                            <!-- eslint-disable vue/no-v-html -->
                                            <p v-html="recentCampaign.itemDescriptionBody" />
                                            <!-- eslint-enable vue/no-v-html -->
                                        </div>
                                        <div v-else>
                                            <div v-for="(body, ind) in (recentCampaign.itemDescriptionBody.split('.'))" :key="ind">
                                                {{ body }} <br />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="campaign-seq">
                                        <span>
                                            {{ recentCampaign.funnelName }}
                                            <ds-icon v-if="recentCampaign.flowName" class="play-icon" name="play-fill" />
                                            {{ recentCampaign.flowName }}
                                        </span>
                                    </div>
                                    <div class="info-section">
                                        <p class="info-msg">
                                            <span v-if="recentCampaign.infoMsg">{{ recentCampaign.infoMsg }}</span>
                                        </p>
                                        <p>
                                            <span v-if="recentCampaign.errorMsg" class="error-msg">{{ recentCampaign.errorMsg }}</span>
                                        </p>
                                        <p>
                                            <span v-if="recentCampaign.warnMsg" class="warn-msg">{{ recentCampaign.warnMsg }}</span>
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    <div v-for="(body, ind) in (recentCampaign.funnelItemDate.split(','))" :key="ind">
                                        <span> {{ body }} </span>
                                    </div>

                                    <div class="campaign-action">
                                        <ds-outline-button
                                            v-if="!(recentCampaign.flowItemType === 'NULL' || recentCampaign.flowItemType === 'Wait')"
                                            style="width: max-content;"
                                            data-qa="perform-action"
                                            @click="createActions(recentCampaign)"
                                        >
                                            {{ recentCampaign.reprocessButtonLabel }}
                                        </ds-outline-button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <div v-else class="no-data" data-qa="no-recent-seq">
                There is no recent automation history for {{ contact.firstName }}.
            </div>
        </div>
        <div class="sequence-sub-header">
            <div class="campaigns-sub-header">
                <h3>Upcoming campaign items</h3>
            </div>

            <div v-if="isUpcomingSequences" data-qa="upcoming-seq-table">
                <table class="upcoming-table-scroller">
                    <tr v-for="(upcomingCampaign, index) in upComingCampaigns" :key="index" class="camp-row">
                        <td style="width: 5%">
                            <div class="icon-section">
                                <ds-icon class="external-look" name="note" />
                            </div>
                        </td>
                        <td>
                            <div data-qa="recent-seq-detail" class="seq-details">
                                <div>
                                    <div class="sequence-info">
                                        <h6 class="semibold">
                                            {{ upcomingCampaign.itemDescriptionTitle }}
                                        </h6>

                                        <div v-if="upcomingCampaign.flowItemType.endsWith('Email')">
                                            <!-- eslint-disable vue/no-v-html -->
                                            <p v-html="upcomingCampaign.itemDescriptionBody" />
                                            <!-- eslint-enable vue/no-v-html -->
                                        </div>

                                        <div v-else>
                                            <div v-for="(body, ind) in (upcomingCampaign.itemDescriptionBody.split('.'))" :key="ind">
                                                {{ body }} <br />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="campaign-seq">
                                        <span>
                                            {{ upcomingCampaign.funnelName }}
                                            <ds-icon v-if="upcomingCampaign.flowName" class="play-icon" name="play-fill" />
                                            {{ upcomingCampaign.flowName }}
                                        </span>
                                    </div>
                                    <div class="info-section">
                                        <p class="info-msg">
                                            <span v-if="upcomingCampaign.infoMsg">{{ upcomingCampaign.infoMsg }}</span>
                                        </p>
                                        <p>
                                            <span v-if="upcomingCampaign.errorMsg" class="error-msg">{{ upcomingCampaign.errorMsg }}</span>
                                        </p>
                                        <p>
                                            <span v-if="upcomingCampaign.warnMsg" class="warn-msg">{{ upcomingCampaign.warnMsg }}</span>
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    <div v-for="(body, ind) in (upcomingCampaign.funnelItemDate.split(','))" :key="ind">
                                        <span> {{ body }} </span>
                                    </div>

                                    <div class="camp-buttons-section">
                                        <div class="camp-buttons campaign-action">
                                            <ds-outline-button
                                                v-if="!(upcomingCampaign.flowItemType === 'NULL' || upcomingCampaign.flowItemType === 'Wait')"
                                                style="width: max-content;"
                                                data-qa="stop-sequence"
                                                width="200"
                                                @click="createActions(upcomingCampaign)"
                                            >
                                                {{ upcomingCampaign.processButtonLabel }}
                                            </ds-outline-button>
                                        </div>

                                        <div class="camp-buttons">
                                            <ds-outline-button
                                                data-qa="stop-sequence"
                                                @click="cancelUpcomingSequence(upcomingCampaign)"
                                            >
                                                Cancel
                                            </ds-outline-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div v-else class="no-data" data-qa="no-upcoming-seq">
                There are no upcoming Sequences for {{ contact.firstName }}.
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import AddSequenceToContactForm from './AddSequenceToContactForm';

export default {
    components: { AddSequenceToContactForm },
    props: {
        contact: Object,
    },

    data() {
        return {
            url: '/app/funnel',
            activeSequences: [],
            recentCampaigns: [],
            upComingCampaigns: [],
            offset: 0,
            limit: 25,
            loading: true,
            isCreated: false,
        };
    },

    created() {
        this.loadActiveSequences();
        this.loadRecentCampaigns();
        this.loadUpcomingCampaigns();
    },

    mounted() {
        this.$root.$on('LOAD_CAMP', (isSuccess) => {
            if (isSuccess) {
                this.loadActiveSequences();
                this.loadUpcomingCampaigns();
            }
        });
    },

    beforeDestroy() {
        this.$root.$off('LOAD_CAMP');
    },

    computed: {
        isActiveSequences() {
            return Boolean(this.activeSequences?.length);
        },

        isRecentActivities() {
            return Boolean(this.recentCampaigns?.length);
        },

        isUpcomingSequences() {
            return Boolean(this.upComingCampaigns?.length);
        },
    },

    methods: {
        async loadActiveSequences() {
            try {
                const onScrollActiveSequences = await axios.get(`${this.url}/activeSequences/${this.contact?.id}`);

                this.activeSequences = onScrollActiveSequences?.data;

                if (onScrollActiveSequences?.data.length < this.limit) {
                    this.noMoreData = true;
                }
            } catch (error) {
                this.$error({ message: 'Unable to get active sequences for this contact' });
            }
        },

        async loadRecentCampaigns() {
            const onScrollRecentSequences = await axios.get(`${this.url}/recentSequences/${this.contact?.id}`);

            this.recentCampaigns = onScrollRecentSequences?.data;
        },

        async loadUpcomingCampaigns() {
            try {
                const onScrollRecentSequences = await axios.get(`${this.url}/upcomingSequences/${this.contact?.id}`);

                this.upComingCampaigns = onScrollRecentSequences?.data;
            } catch (error) {
                this.$error({ message: 'Unable to get upcoming sequences for this contact' });
            }
        },

        async removeSequence(activeSequence) {
            await this.$confirm({
                message: 'Are you sure you want to remove this campaign?',
                confirmLabel: 'Ok',
                cancelLabel: 'Cancel',
            }).then(() => {
                this.stopSequence(activeSequence);
            });
        },

        async cancelUpcomingSequence(upcomingSequence) {
            await this.$confirm({
                message: 'Are you sure you want to cancel this campaign?',
                confirmLabel: 'Ok',
                cancelLabel: 'Cancel',
            }).then(() => {
                this.cancelActions(upcomingSequence);
            });
        },

        async stopSequence(activeSequence) {
            try {
                const params = `funnelId=${activeSequence.funnelId}&flowId=${activeSequence.flowId}`;

                await axios.get(`${this.url}/stopSequence/${this.contact?.id}?${params}`);
                this.loadActiveSequences();
            } catch (error) {
                this.$error({ message: 'Unable to stop sequence' });
            }
        },

        showAddSequenceModal() {
            this.$refs.sequenceModal.showModal();
        },

        async createActions(sequence) {
            await this.$confirm({
                message: `Are you sure you want to ${sequence.itemDescriptionTitle}?`,
                confirmLabel: 'Ok',
                cancelLabel: 'Cancel',
            }).then(() => {
                this.performAction(sequence);
            });
        },

        async performAction(sequence) {
            try {
                await axios.get(`/app/flowItemFunnel/reProcessContactFlowItem/${sequence.flowItemId}`);
            } catch (error) {
                this.$error({ message: 'Unable to create given action for this contact' });
            }
        },

        async cancelActions(sequence) {
            try {
                await axios.get(`/app/flowItemFunnel/cancelContactFlowItem/${sequence.flowItemId}`);
                this.loadUpcomingCampaigns();
            } catch (error) {
                this.$error({ message: 'Unable to create given action for this contact' });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.campaigns-header {
    display: flex;
    justify-content: space-between;
    padding: 1.2rem 0;
    border-bottom: solid px-to-rem(1px) $color-gray-200;
    align-items: center;
}

.campaigns-sub-header {
    padding: $spacing-200 0;
    align-items: center;
}

h6 {
    margin-bottom : 0.3rem;
    text-transform: none;
}

.no-data {
    font-size: 1.2rem;
    padding: $spacing-600 0 $spacing-200;
    text-align: center;
    color: $color-gray-darker;
}

.funnel-body {
    display: flex;
    flex-wrap: wrap;
    justify-items:  left;
    justify-content: space-between;
}

.flow-name {
    flex: 75;
}

.play-icon {
    --icon-size: 0.7rem;
}

.seq-details {
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-top: auto;
    margin-bottom: auto;
    cursor: pointer;
}

.seq-remove {
    display: grid;
    justify-content: space-around;
}

.campaign-seq {
    font-size: $font-size-md;
    display: flex;
    margin-top: $spacing-125;
}

.sequence-header {
    margin-top: $spacing-250;
}

.campaign-action {
    margin-top: $spacing-100;
    width: 6.25rem;
}

.table-scroller {
    flex-flow: row nowrap;
    overflow-x: auto;
}

.sequence-info {
    color: $color-gray;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
}

.upcoming-table-scroller > tr:last-child {
    border-bottom: 0;
}

.table-scroller::-webkit-scrollbar {
    display: none;
}

.camp-buttons-section {
    display: contents;
}

.camp-buttons {
    display: block;
    margin-bottom: 0.32rem;
}

.icon-section {
    align-content: start;
}

.info-msg {
    background-color: rgb(189, 229, 248);
    margin-top: $spacing-200;
    padding-left: 0.32rem;
    padding-right: 0.32rem;
}

.warn-msg {
    background-color: $color-yellow;
    margin-top: $spacing-200;
    padding-left: 0.32rem;
    padding-right: 0.32rem;
}

.error-msg {
    background-color: rgb(255, 210, 210);
    margin-top: $spacing-200;
    padding-left: 0.32rem;
    padding-right: 0.32rem;
}

.camp-row:hover {
     background-color: $color-gray-100;
     cursor: pointer;
}
</style>
